import "./bootstrap";
import "../css/app.css";

import { createRoot, hydrateRoot } from "react-dom/client";
import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

const appName = import.meta.env.VITE_APP_NAME;

import { Ziggy } from "./ziggy.js";
import route from "ziggy-js";

createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx"),
        ),
    setup({ el, App, props }) {
        globalThis.Ziggy = Ziggy;
        globalThis.route = route;

        window.route = route;
        window.Ziggy = Ziggy;

        process.env.NODE_ENV !== "production"
            ? createRoot(el).render(<App {...props} />)
            : hydrateRoot(el, <App {...props} />);

        delete el.dataset.page;
    },
    progress: {
        color: "#393ABF",
    },
});

router.on("navigate", (event) => {
    if (typeof window !== undefined) {
        window.dataLayer.push({
            event: "page_view",
            page_location: event.detail.page.url,
            page_title: event.detail.page.component,
        });
    }
});
